module.exports = __webpack_public_path__ + "static/media/not-found.42f7cbb6.svg";